import React, { useEffect, useState } from 'react';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import Table from '../../../core/common/dataTable/index';
import { createOrgUser, fetchOrgUsers, updateOrgUser } from '../../../core/data/redux/service/OrgUserService';
import { fetchOrgRoles } from '../../../core/data/redux/service/OrgRoleService';
import { formatError, formatSuccess } from '../../../core/data/redux/service/AuthService';
import { AxiosResponse } from 'axios';

const emptyForm = { name: '', email: '', phoneNumber: '', role: '', active: true };

const OrgUsers = () => {
  const [data, setData] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState<any>(null);

  const load = () =>
    Promise.all([
      fetchOrgUsers(0, 100).then((res: AxiosResponse) => setData(res.data.content || [])),
      fetchOrgRoles(0, 100).then((res: AxiosResponse) => setRoles(res.data.content || [])),
    ]).catch(err => formatError(err));

  useEffect(() => { load(); }, []);

  const columns = [
    { title: 'Name', dataIndex: 'name' },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Mobile', dataIndex: 'phoneNumber' },
    { title: 'Role', dataIndex: 'role' },
    { title: 'Active', dataIndex: 'active', render: (v: boolean) => v ? 'Yes' : 'No' },
    {
      title: 'Action',
      render: (_: unknown, record: any) => (
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => {
          setEditing(record);
          setForm({
            name: record.name,
            email: record.email,
            phoneNumber: record.phoneNumber,
            role: record.role,
            active: record.active,
          });
        }}>Edit</button>
      ),
    },
  ];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      name: form.name,
      email: form.email,
      phoneNumber: form.phoneNumber,
      role: form.role,
      active: form.active,
      userName: editing?.userName,
    };
    const req = editing ? updateOrgUser(payload) : createOrgUser(payload);
    req.then(() => {
      formatSuccess(editing ? 'User updated' : 'User created');
      setForm(emptyForm);
      setEditing(null);
      load();
    }).catch(err => formatError(err));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2"><h2 className="mb-1">Organisation Users</h2></div>
          <div className="head-icons ms-2"><CollapseHeader /></div>
        </div>
        <div className="card mb-3">
          <div className="card-body">
            <form className="row g-3" onSubmit={handleSubmit}>
              <div className="col-md-3">
                <input className="form-control" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
              </div>
              <div className="col-md-3">
                <input className="form-control" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
              </div>
              <div className="col-md-2">
                <input className="form-control" placeholder="Mobile" value={form.phoneNumber} onChange={e => setForm({ ...form, phoneNumber: e.target.value })} required />
              </div>
              <div className="col-md-2">
                <select className="form-select" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} required>
                  <option value="">Role</option>
                  {roles.map((r: any) => <option key={r.role} value={r.role}>{r.role}</option>)}
                </select>
              </div>
              <div className="col-md-2">
                <button type="submit" className="btn btn-primary w-100">{editing ? 'Update' : 'Add User'}</button>
              </div>
            </form>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <Table columns={columns} dataSource={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgUsers;
